// 获取多少天之前的日期
export function computedLastData(xx) {
  // 获取当前日期
  const currentDate = new Date()

  // 设置要推算的天数
  const daysAgo = xx // 替换为具体的天数

  // 计算指定天数之前的日期
  currentDate.setDate(currentDate.getDate() - daysAgo)

  // 格式化日期为 "YYYY-MM-DD" 格式
  const year = currentDate.getFullYear()
  const month = ('0' + (currentDate.getMonth() + 1)).slice(-2)
  const day = ('0' + currentDate.getDate()).slice(-2)
  return year + '-' + month + '-' + day
}
